import React, { useRef } from 'react';

const BOX_CLASSES =
  'w-12 h-14 rounded-xl border-[3px] border-black bg-white text-center text-lg font-semibold tracking-wider';

export const RoomCodeInput = ({ value, onChange, length }) => {
  const inputsRef = useRef([]);
  const digits = Array.from({ length }, (_, idx) => value[idx] || '');

  const handleChange = (idx, evt) => {
    const digit = (evt.target.value || '').replace(/\D/g, '').slice(-1);
    const updated = [...digits];
    updated[idx] = digit;
    onChange(updated.join(''));
    if (digit && idx < length - 1) {
      const nextInput = inputsRef.current[idx + 1];
      nextInput?.focus();
      nextInput?.select?.();
    }
  };

  const handleKeyDown = (idx, evt) => {
    if (evt.key === 'Backspace') {
      evt.preventDefault();
      const updated = [...digits];
      if (updated[idx]) {
        updated[idx] = '';
        onChange(updated.join(''));
        return;
      }
      if (idx > 0) {
        updated[idx - 1] = '';
        onChange(updated.join(''));
        inputsRef.current[idx - 1]?.focus();
      }
      return;
    }
    if (evt.key === 'ArrowLeft' && idx > 0) {
      evt.preventDefault();
      inputsRef.current[idx - 1]?.focus();
      return;
    }
    if (evt.key === 'ArrowRight' && idx < length - 1) {
      evt.preventDefault();
      inputsRef.current[idx + 1]?.focus();
    }
  };

  const handlePaste = (evt) => {
    const text = evt.clipboardData?.getData('text') || '';
    const clean = text.replace(/\D/g, '').slice(0, length);
    if (!clean) return;
    evt.preventDefault();
    onChange(clean);
    const targetIdx = Math.min(clean.length, length - 1);
    inputsRef.current[targetIdx]?.focus();
    inputsRef.current[targetIdx]?.select?.();
  };

  return (
    <div className="flex gap-2 justify-center" onPaste={handlePaste}>
      {digits.map((digit, idx) => (
        <input
          key={idx}
          ref={(el) => {
            inputsRef.current[idx] = el;
          }}
          value={digit}
          onChange={(e) => handleChange(idx, e)}
          onKeyDown={(e) => handleKeyDown(idx, e)}
          inputMode="numeric"
          maxLength={1}
          autoComplete="one-time-code"
          className={`${BOX_CLASSES} flex items-center justify-center p-0 appearance-none focus:outline-none focus:border-gray-700`}
        />
      ))}
    </div>
  );
};

export const RoomCodeDisplay = ({ code, length }) => {
  const digits = Array.from({ length }, (_, idx) => code[idx] || '');
  return (
    <div className="flex gap-2 justify-center">
      {digits.map((digit, idx) => (
        <div key={idx} className={`${BOX_CLASSES} flex items-center justify-center`}>
          {digit}
        </div>
      ))}
    </div>
  );
};
